module.exports = __webpack_public_path__ + "img/lv2.88c0d068.png";